import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useEffect} from "react";

export default function FprBreadCrumbs({tab, setTab, selectedTemplate, fprDataSaved}) {
    const { id } = useParams();
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const handleClick = (tabName) => {
        setTab(tabName)
        if (pathname.includes("faire-part-avis-de-deces")) {
            navigate(`/defunt/${id}/faire-part-avis-de-deces/${tabName}`)
        } else {
            navigate(`/defunt/${id}/faire-part-remerciement/${tabName}`)
        }
    }

    const finaliserStep = selectedTemplate?.photo ? 4 : 3;

    return (
        <div className="flex breadcrumb">
            <button className={tab === "modifier" ? "active arrow-button" : "arrow-button" } disabled={fprDataSaved?.error && "disabled"} value="modifier" onClick={() => handleClick("modifier")} >1.Choisir le thème</button>
            <button className={tab === "donnees" ? "active arrow-button" : "arrow-button" } disabled={fprDataSaved?.error && "disabled"} value="donnees" onClick={() => handleClick("donnees")}>2.Compléter les données</button>
            {selectedTemplate?.photo && <button className={tab === "photo" ? "active arrow-button" : "arrow-button" } disabled={fprDataSaved?.error && "disabled"} value="photo" onClick={() => handleClick("photo")} >3.Photo</button>}
            <button className={tab === "finaliser" ? "active arrow-button" : "arrow-button" } value="finaliser" disabled={fprDataSaved?.error && "disabled"} onClick={() => handleClick("finaliser")} >{finaliserStep}.Finaliser le faire-part</button>
        </div>
    )
}